import API from '..';
export const questionAdminApi = {
  updateQuestionsByGdoc: async (input: { url: string }) => {
    return API.post('/admin/question/updateByDoc', { ...input });
  },
};
